import { useTranslations } from 'next-intl';

export const DeliveryMethodSwitchSuccess = () => {
  const tDeliveryBarToasts = useTranslations('DeliveryBar.Toasts');

  return (
    <div>
      <span className="tw-lf-body-bold-md">
        {tDeliveryBarToasts('shippingMethodSelected')}
      </span>
      <br />
      <span className="tw-lf-body-regular-md">
        {tDeliveryBarToasts('changeToZWToastMessage')}
      </span>
    </div>
  );
};
